import React, { Fragment } from 'react';
import Spinner from './Spinner';
var Button = function (_a) {
    var _b = _a.label, label = _b === void 0 ? 'label' : _b, _c = _a.style, style = _c === void 0 ? 'primary' : _c, _d = _a.disabled, disabled = _d === void 0 ? false : _d, _e = _a.loading, loading = _e === void 0 ? false : _e, icon = _a.icon, id = _a.id, _f = _a.onClick, onClick = _f === void 0 ? function () { return console.log('No action assigned to button'); } : _f, _g = _a.type, type = _g === void 0 ? 'default' : _g;
    var handleClick = function (e) {
        e.preventDefault();
        onClick();
    };
    var buttonType = {
        base: 'flex flex-row align-middle items-center justify-center gap-3',
        default: 'px-4 h-12',
        block: 'px-4 h-12 w-full',
        square: 'flex-col p-2 py-3 gap-1 text-xs text-center w-14',
    };
    var buttonStyle = {
        base: "rounded-lg disabled:bg-gray-darkest disabled:cursor-not-allowed duration-100 whitespace-nowrap",
        primary: 'bg-gray text-primary hover:bg-gray-darkest',
        secondary: 'bg-gray text-secondary hover:bg-gray-darkest hover:text-primary',
        tertiary: 'text-accent-primary',
        ghost: 'text-secondary hover:bg-gray-darkest hover:text-primary',
        destroy: 'text-[#E44141] bg-[#401313] hover:bg-[darkred] hover:text-white',
        accent: 'bg-accent hover:brightness-110',
    };
    return (React.createElement("button", { id: id, className: buttonStyle.base +
            ' ' +
            buttonStyle[style] +
            ' ' +
            buttonType.base +
            ' ' +
            buttonType[type], onClick: handleClick, disabled: disabled || loading }, loading ? (React.createElement(Spinner, { size: '1.5rem' })) : (React.createElement(Fragment, null,
        icon ? React.createElement("div", { className: 'w-6 text-center' }, icon()) : '',
        React.createElement("p", { className: '' }, label)))));
};
export default Button;
